import "./IntegrateTeleOrWhatsApp.css";

const IntegrateTeleOrWhatsApp = () => {
  return (
    <div className="integrate-tw-docs">
      <h1 className="integrate-tw-title">Use Bot via Telegram / WhatsApp</h1>

      <p className="integrate-tw-intro">
        Connect your chatbot to WhatsApp Business or Telegram to interact with users directly on these platforms. Currently, our team sets up these integrations manually upon your request.
      </p>

      <h2 className="integrate-tw-step">Step 1: Select Your Bot</h2>
      <p className="integrate-tw-intro">
        Navigate to <strong>Your Bots</strong> in the Xenachat dashboard and select the bot you want to integrate.
      </p>

      <h2 className="integrate-tw-step">Step 2: Open Integrations</h2>
      <p className="integrate-tw-intro">
        Click on the <strong>Integrations</strong> button in the left sidebar to view available integration options.
      </p>

      <h2 className="integrate-tw-step">Step 3: Request Integration</h2>
      <p className="integrate-tw-intro">
        For WhatsApp, request integration to connect your WhatsApp Business number using the WhatsApp Cloud API. <br />
        For Telegram, request integration to connect your Telegram bot token. <br />
        Our team will handle the technical setup including webhook configuration.
      </p>

      <h2 className="integrate-tw-step">Integration Benefits</h2>
      <ul className="integrate-tw-benefits">
        <li>Uses the same knowledge base and settings as your Xenachat bot</li>
        <li>Messages are logged in your Xenachat Inbox and Analytics</li>
        <li>WhatsApp is ideal for support, FAQs, and lead qualification</li>
        <li>Telegram supports multiple groups/channels with rate and message limits similar to the web widget</li>
        <li>Perfect for communities and product support channels</li>
      </ul>

      <p className="integrate-tw-note">
        Once enabled, your bot will start responding on the chosen channel using the same retrieval, limits, and analytics as your web widget.
      </p>
    </div>
  );
};

export default IntegrateTeleOrWhatsApp;
